import "./sidebar.scss"
import DashboardIcon from '@mui/icons-material/Dashboard'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import {Link} from "react-router-dom"
import { useContext } from "react";
import { DarkModeContext } from "../../context/darkModeContext";

const Sidebar = () => {

  const {dispatch} = useContext(DarkModeContext)

  return (
    <div className="sidebar">
        <div className="top">
          <Link to="/" style={{textDecoration:"none"}}>
          <span className="logo">kutayozel</span>
          </Link>
        </div>
        <hr />
        <div className="center">
          <ul>
            <p className="title">MAIN</p>
            <li>
              <DashboardIcon className = "icon"/>
              <span>Dashboard</span>
            </li>
            <p className="title">LISTS</p>
            <Link to="/users" style={{textDecoration:"none"}}>
              <li>
                <PersonOutlineOutlinedIcon className = "icon"/>
                <span>Users</span>
              </li>
            </Link>
            <Link to="/products" style={{textDecoration:"none"}}>
              <li>
              <ShoppingBagIcon className = "icon"/>
                <span>Products</span>
              </li>
            </Link>
            <li>
            <CreditCardIcon className = "icon"/>
              <span>Orders</span>
            </li>
            <li>
            <LocalShippingIcon className = "icon"/>
              <span>Delivery</span>
            </li>
            <p className="title">USEFUL</p>
            <li>
            <QueryStatsIcon className = "icon"/>
              <span>Stats</span>
            </li>
            <li>
            <NotificationsNoneIcon className = "icon"/>
              <span>Notifications</span>
            </li>
            <p className="title">SERVICE</p>
            <li>
            <WysiwygIcon className = "icon"/>
              <span>System Health</span>
            </li>
            <li>
            <ManageSearchIcon className = "icon"/>
              <span>Logs</span>
            </li>
            <li>
            <SettingsOutlinedIcon className = "icon"/>
              <span>Settings</span>
            </li>
            <p className="title">USER</p>
            <li>
            <AccountCircleOutlinedIcon className = "icon"/>
              <span>Profile</span>
            </li>
            <li>
            <ExitToAppOutlinedIcon className = "icon"/>
              <span>Logout</span>
            </li>
          </ul>
        </div>
        <div className="bottom">
          <div 
            className="colorOption" 
            onClick={() => dispatch({type: "LIGHT"})}
          ></div>
          <div 
            className="colorOption"
            onClick={() => dispatch({type: "DARK"})}
          ></div>
        </div>
    </div>
  )
}

export default Sidebar